import mealsData from './shared/state';

export default {
  modules: {
    mealsData,
  },
};
